import type { IpBlockingIsp } from "@nexus/widget-kit";

export const count = new Intl.NumberFormat("en");

const ratio = new Intl.NumberFormat("en", {
  style: "percent",
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export const percent = (value: number | null | undefined) =>
  value == null ? "Unavailable" : ratio.format(value);

export const clamp = (value: number) => Math.min(1, Math.max(0, value));

/** Presentation bands shared with ISP Blocking Rate, not operational alarms. */
const RATE_OK = 0.7;
export const RATE_LOW = 0.4;

/** Eligible ISPs ordered by blocking rate, then sending count and name. */
export function rankIsps(isps: readonly IpBlockingIsp[]): IpBlockingIsp[] {
  return isps
    .filter((item) => item.ratio != null && item.eligibleSendings > 0)
    .sort(
      (first, second) =>
        (first.ratio ?? 0) - (second.ratio ?? 0) ||
        first.blockedSendings - second.blockedSendings ||
        first.isp.localeCompare(second.isp),
    );
}

export function rateColor(value: number | null | undefined): string {
  if (value == null) return "text-muted";
  if (value >= RATE_OK) return "text-status-ok-text";
  if (value >= RATE_LOW) return "text-status-warn-text";
  return "text-status-error-text";
}
